export default {"src":"/intl/_next/static/media/LogoUTUA.8fea6c58.svg","height":34,"width":71,"blurWidth":0,"blurHeight":0};